<template>
    <div class="flex relative my-auto container mx-auto">

      <PrevArrow prev="sub-concept-two"/>

      <div class="subsection-big-circle bg-black rounded-full mx-auto">
        <h1 class="deep-info-sub-heading text-white mx-auto pt-20 text-2xl font-bold leading-tight">STREAM <br>ARCHITECTURE</h1>

        <img src="https://blissing.s3-us-west-1.amazonaws.com/img/pdf-images/Process+Module+-+Streams.png" alt="pdf image"
        class="mx-auto cursor-pointer" @click="showPdf()">

      </div>

      <NextArrow next="sub-concept-four"/>

    </div>
</template>

<script>
import PrevArrow from "@/components/deepinfo/subnavigation/PrevArrow.vue";
import NextArrow from "@/components/deepinfo/subnavigation/NextArrow.vue";

export default {
  name: "ConceptSubThree",
  props:{
    pdfUrl:{
      required: true,
      type: String,
    }
  },
  components:{
    PrevArrow,
    NextArrow
  },
  methods:{
    showPdf(){
      // Event.$emit('openPdf', pdf);
      window.open(this.pdfUrl);
    }
  }
}
</script>
